var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-collapse",
        {
          staticClass: "paddingRight10 paddingLeft10 labelGray",
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "订单商品", name: "0" } },
            _vm._l(_vm.seller, function (product, index) {
              return _c(
                "div",
                { key: index, staticClass: "marginBottom10" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c(
                          "div",
                          { staticClass: "bg-purple" },
                          [
                            product.goodsId === undefined
                              ? _c("el-image", {
                                  staticClass: "h100 w100 borderRed",
                                  attrs: {
                                    src: _vm.noGoodsUrl,
                                    "preview-src-list": [_vm.noGoodsUrl],
                                    fit: "fit",
                                  },
                                })
                              : _c("el-image", {
                                  staticClass: "h100 w100",
                                  attrs: {
                                    src: product.c_master_url,
                                    "preview-src-list": [product.c_master_url],
                                    fit: "fit",
                                  },
                                }),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 16 } }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "bg-purple-light h100 flex directionColumn",
                            staticStyle: { "justify-content": "space-between" },
                          },
                          [
                            product.goodsId !== undefined
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "blue",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleViewGoods(
                                          product.goodsId,
                                          product.r_sort,
                                          null
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(product.c_name))]
                                )
                              : _c("div", { staticClass: "elRed" }, [
                                  _vm._v(_vm._s(product.c_name)),
                                ]),
                            _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 11 } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "shop:shopAuthorize:sellStart",
                                            ],
                                            expression:
                                              "['shop:shopAuthorize:sellStart']",
                                          },
                                        ],
                                        attrs: {
                                          type: "warning",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSellStartOrOver(
                                              product.c_barcode,
                                              1
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("售罄")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "shop:shopAuthorize:sellOver",
                                            ],
                                            expression:
                                              "['shop:shopAuthorize:sellOver']",
                                          },
                                        ],
                                        attrs: {
                                          type: "warning",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSellStartOrOver(
                                              product.c_barcode,
                                              2
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("复售")]
                                    ),
                                  ],
                                  1
                                ),
                                _c("el-col", { attrs: { span: 13 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "textRight",
                                      style: {
                                        color:
                                          product.num > 1 ? "red" : "black",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "实际价格：￥" +
                                              _vm._s(
                                                _vm._f("parsePrice")(
                                                  product.price
                                                )
                                              )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "20px",
                                          },
                                        },
                                        [_vm._v("x" + _vm._s(product.num))]
                                      ),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "订单拣货", name: "1" } },
            [
              _vm._l(_vm.goods, function (product, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "marginBottom10" },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            { staticClass: "bg-purple" },
                            [
                              product.rinventory !== undefined
                                ? _c("el-image", {
                                    staticClass: "h100 w100",
                                    attrs: {
                                      src: product.cmasterUrl,
                                      "preview-src-list": [product.cmasterUrl],
                                      fit: "fit",
                                    },
                                  })
                                : _c("el-image", {
                                    staticClass: "h100 w100 borderRed",
                                    attrs: {
                                      "preview-src-list": [_vm.noGoodsUrl],
                                      fit: "fit",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 16 } }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-purple-light h100 flex directionColumn",
                              staticStyle: {
                                "justify-content": "space-between",
                              },
                            },
                            [
                              product.rgoods !== undefined
                                ? _c("a", { staticClass: "blue" }, [
                                    _vm._v(_vm._s(product.sgoods)),
                                  ])
                                : _c("div", { staticClass: "elRed" }, [
                                    _vm._v(_vm._s(product.sgoods)),
                                  ]),
                              _c("div", [
                                _vm._v(
                                  " 货号：" + _vm._s(product.csku) + "， "
                                ),
                                product.zinventory === "已出货" ||
                                product.zinventory === "已取消"
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "red" } },
                                      [
                                        _vm._v(
                                          "库位号：" +
                                            _vm._s(product.zinventory)
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        "库位号：" + _vm._s(product.zinventory)
                                      ),
                                    ]),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "textRight",
                                  style: {
                                    color: product.nout > 1 ? "red" : "black",
                                  },
                                },
                                [_vm._v("x" + _vm._s(product.nout))]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: product.goodsRemark,
                                      expression: "product.goodsRemark",
                                    },
                                  ],
                                  staticStyle: {
                                    position: "absolute",
                                    bottom: "0",
                                  },
                                },
                                [
                                  _vm._v(
                                    "货品备注: " + _vm._s(product.goodsRemark)
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "bcGrey h50 padding10 borderRadius5" },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "100px" },
                          attrs: { span: 11 },
                        },
                        [
                          _c("div", { staticClass: "grey" }, [
                            _vm._v("用户备注"),
                          ]),
                          _vm.orderInfo.sorderRemark === undefined ||
                          _vm.orderInfo.sorderRemark === ""
                            ? _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.orderRemarkDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("点击添加备注")]
                              )
                            : _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.orderRemarkDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.orderInfo.sorderRemark))]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { height: "100px" },
                          attrs: { span: 11, offset: 2 },
                        },
                        [
                          _c("div", { staticClass: "grey" }, [
                            _vm._v("内部备注"),
                          ]),
                          _vm.orderInfo.sadditionalRemark === undefined ||
                          _vm.orderInfo.sadditionalRemark === ""
                            ? _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.sadditionalRemarkDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("点击添加备注")]
                              )
                            : _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.sadditionalRemarkDialogVisible = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.orderInfo.sadditionalRemark)
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "bcGrey h50 padding10 borderRadius5" },
                [
                  _vm.pickInfo && _vm.pickInfo.zstate === 1
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:pickEdit"],
                              expression: "['order:orderProcessing:pickEdit']",
                            },
                          ],
                          staticStyle: { float: "right" },
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.openPicking(_vm.orderInfo.rpicking)
                            },
                          },
                        },
                        [_vm._v("修改")]
                      )
                    : _vm._e(),
                  _vm.pickInfo && _vm.pickInfo.zstate === 2
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:pickEdit"],
                              expression: "['order:orderProcessing:pickEdit']",
                            },
                          ],
                          staticStyle: { float: "right", "margin-left": "5px" },
                          attrs: { type: "primary", plain: "" },
                          on: {
                            click: function ($event) {
                              _vm.pickingShipmentDialogVisible = true
                            },
                          },
                        },
                        [_vm._v("出货")]
                      )
                    : _vm._e(),
                  _vm.pickInfo && _vm.pickInfo.zstate === 2
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:pickEdit"],
                              expression: "['order:orderProcessing:pickEdit']",
                            },
                          ],
                          staticStyle: { float: "right", "margin-left": "5px" },
                          attrs: { type: "danger", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.openPickingUpdate(
                                _vm.orderInfo.rpicking
                              )
                            },
                          },
                        },
                        [_vm._v("改单")]
                      )
                    : _vm._e(),
                  _vm.pickInfo && _vm.pickInfo.zstate === 2
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:pickEdit"],
                              expression: "['order:orderProcessing:pickEdit']",
                            },
                          ],
                          staticStyle: { float: "right", "margin-left": "5px" },
                          attrs: { type: "danger", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.openPickingCancel(
                                _vm.orderInfo.rpicking
                              )
                            },
                          },
                        },
                        [_vm._v("取消")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-collapse-item",
            { attrs: { name: "2" } },
            [
              _c("template", { slot: "title" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "space-between",
                      width: "100%",
                    },
                  },
                  [_c("div", [_vm._v("顾客信息")])]
                ),
              ]),
              _c(
                "el-descriptions",
                { attrs: { column: 1 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "预定人" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderInfo.ccustomerName +
                          "&性别：" +
                          _vm.orderInfo.ccustomerSex
                      )
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                    _vm._v(_vm._s(_vm.orderInfo.ccustomerPhone)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "隐私号" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "blue",
                        on: {
                          click: function ($event) {
                            return _vm.callPhone(
                              _vm.orderInfo.ccustomerPhonePrivate
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.orderInfo.ccustomerPhonePrivate
                              ? _vm.orderInfo.ccustomerPhonePrivate
                                  .split("_")[0]
                                  .replace(
                                    _vm.orderInfo.ccustomerPhonePrivate.substr(
                                      3,
                                      4
                                    ),
                                    "****"
                                  ) + "_****"
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "备用号" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "blue",
                        on: {
                          click: function ($event) {
                            return _vm.callPhone(
                              _vm.orderInfo.ccustomerPhoneBak
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.orderInfo.ccustomerPhoneBak
                              ? _vm.orderInfo.ccustomerPhoneBak
                                  .split("_")[0]
                                  .replace(
                                    _vm.orderInfo.ccustomerPhoneBak.substr(
                                      3,
                                      4
                                    ),
                                    "****"
                                  ) + "_****"
                              : ""
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "顾客属性" } }, [
                    _vm._v(_vm._s(_vm.orderInfo.ccustomerAttr)),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "订单金额", name: "3" } },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 1 } },
                [
                  _c(
                    "el-descriptions-item",
                    { key: "顾客实付", attrs: { label: "顾客实付" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("parsePrice")(_vm.orderInfo.npriceCustomer)
                        ) + " 元"
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { key: "商家实收", attrs: { label: "商家实收" } },
                    [
                      _vm._v(
                        _vm._s(_vm._f("parsePrice")(_vm.orderInfo.npriceShop)) +
                          " 元"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-collapse-item",
            { attrs: { title: "订单信息", name: "4" } },
            [
              _c(
                "el-descriptions",
                { attrs: { column: 1 } },
                [
                  _c("el-descriptions-item", { attrs: { label: "订单编号" } }, [
                    _vm._v(_vm._s(_vm.orderInfo.corderNo)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "下单时间" } }, [
                    _vm._v(_vm._s(_vm.orderInfo.sorderTime)),
                  ]),
                  _vm.orderInfo.bdelivery === 2
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "自提时间" } },
                        [_vm._v(_vm._s(_vm.orderInfo.swishTime))]
                      )
                    : _c(
                        "el-descriptions-item",
                        { attrs: { label: "要求送达" } },
                        [_vm._v(_vm._s(_vm.orderInfo.swishTime))]
                      ),
                  _vm.orderInfo.soverTime
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "完成时间" } },
                        [_vm._v(_vm._s(_vm.orderInfo.soverTime))]
                      )
                    : _vm._e(),
                  _c("el-descriptions-item", { attrs: { label: "配送门店" } }, [
                    _c(
                      "a",
                      {
                        staticClass: "blue",
                        on: { click: _vm.clickStoreLocation },
                      },
                      [_vm._v(_vm._s(_vm.ccode + _vm.storeName))]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          !(_vm.orderInfo.zflow === 1 || _vm.orderInfo.zflow === 2)
            ? _c(
                "el-collapse-item",
                { attrs: { title: "配送信息", name: "5" } },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 1 } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "配送方式" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("deliveryPlatform")(_vm.orderInfo.logistic)
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "配送费用" } },
                        [_vm._v(_vm._s(_vm.orderInfo.ndeliveryPrice))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "骑手姓名" } },
                        [_vm._v(_vm._s(_vm.orderInfo.cdeliveryName))]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "骑手电话" } },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "blue",
                              on: {
                                click: function ($event) {
                                  return _vm.callPhone(
                                    _vm.orderInfo.cdeliveryPhone
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.orderInfo.cdeliveryPhone))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.imDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "elDialog my_dialog",
              attrs: {
                "custom-class": "customDialog",
                "close-on-click-modal": false,
                title: "客服中心",
                visible: _vm.imDialogVisible,
                width: "700px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.imDialogVisible = $event
                },
              },
            },
            [
              _vm.imDialogVisible
                ? _c("imDialog", { attrs: { "order-id": _vm.orderId } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.storeLocationDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "elDialog",
              attrs: {
                "close-on-click-modal": false,
                title: "门店位置",
                visible: _vm.storeLocationDialogVisible,
                width: "800px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.storeLocationDialogVisible = $event
                },
              },
            },
            [
              _vm.storeLocationDialogVisible
                ? _c("getStoreLocation", {
                    attrs: { "store-id": _vm.orderInfo.rstore },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          staticStyle: { "margin-top": "-10vh" },
          attrs: {
            "close-on-click-modal": false,
            title: "修改拣货单",
            visible: _vm.editOrUpdatePickingDialogVisible,
            width: "1200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editOrUpdatePickingDialogVisible = $event
            },
          },
        },
        [
          _vm.editOrUpdatePickingDialogVisible
            ? _c("editPicking", {
                attrs: { "picking-id": _vm.pickInfo.sid },
                on: { handleClose: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "拣货出库",
            visible: _vm.pickingShipmentDialogVisible,
            width: "1200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pickingShipmentDialogVisible = $event
            },
          },
        },
        [
          _vm.pickingShipmentDialogVisible
            ? _c("pickingShipment", {
                attrs: { sid: _vm.pickInfo.sid },
                on: {
                  handleClose: _vm.handleClose,
                  handleUpdate: _vm.handleClose,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "用户备注",
            visible: _vm.orderRemarkDialogVisible,
            width: "200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderRemarkDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: 3 },
            model: {
              value: _vm.orderInfo.sorderRemark,
              callback: function ($$v) {
                _vm.$set(_vm.orderInfo, "sorderRemark", $$v)
              },
              expression: "orderInfo.sorderRemark",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.orderRemarkDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleOrderRemark },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "elDialog",
          attrs: {
            "close-on-click-modal": false,
            title: "内部备注",
            visible: _vm.sadditionalRemarkDialogVisible,
            width: "200px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.sadditionalRemarkDialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { type: "textarea", rows: 3 },
            model: {
              value: _vm.orderInfo.sadditionalRemark,
              callback: function ($$v) {
                _vm.$set(_vm.orderInfo, "sadditionalRemark", $$v)
              },
              expression: "orderInfo.sadditionalRemark",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sadditionalRemarkDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleAdditionalRemark },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }